import axios from "axios";
import {baseUrl} from "../Univ";
// ===========================================
// START CONVERSATION
// ===========================================
export async function startConversation(language) {
    const res = await axios.post(`${baseUrl}ai-registration/start/`, {
        language
    });
    console.log("START RESPONSE", res);
    return res.data;
}
// ===========================================
// CHAT
// ===========================================
export async function chat(conversation_id, message, language) {
    const res = await axios.post(`${baseUrl}ai-registration/chat/`, {
        conversation_id, message, language
    });
    return res.data;
}
// ===========================================
// RESET
// ===========================================
export async function resetConversation(conversation_id) {
    await axios.post(`${baseUrl}ai-registration/reset/`, {
        conversation_id
    });
}
// ===========================================
// WHISPER
// ===========================================
export async function uploadAudio(blob, language) {
    const form = new FormData();
    form.append("audio", blob, "speech.webm");
    form.append("language", language);
    const res = await axios.post(`${baseUrl}ai-registration/whisper/`, form, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return res.data;
}
// ===========================================
// TEXT TO SPEECH
// ===========================================
export function playVoice(url) {
    if (!url) return;
    const audio = new Audio(`${window.location.origin}${url}`);
    audio.play();
}
// ===========================================
// SAVE PATIENT
// ===========================================
export async function savePatient(patient, userName, ipAddress, userLocation) {
    const id = await axios.post(`${baseUrl}get_pat_id/`);
    const pat_id = id.data.value;
    const form = new FormData();
    form.append("pat_id", pat_id);
    Object.keys(patient).forEach(key => {
        form.append(key, patient[key] || "");
    });
    form.append("refered", "AI Reception");
    form.append("status", "1");
    form.append("addedby", userName);
    form.append("ip_add", ipAddress);
    form.append("location", userLocation);
    await axios.post(`${baseUrl}add-patient/`, form);
    return pat_id;
}
export async function saveAIRegistration(conversation_id, location = 1, addedby = "AI") {
    const res = await axios.post(`${baseUrl}ai-registration/save/`, {
        conversation_id, location, addedby
    });
    return res.data;
}
// =====================================================
// IDENTITY OCR
// =====================================================
// =====================================================
// IDENTITY OCR / CAMERA SCAN
// =====================================================
export const scanIdentityDocument = async (file, documentType) => {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("document_type", documentType);
    const response = await axios.post(`${baseUrl}identity/camera/`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return response.data;
};
// =====================================================
// SAVE IDENTITY PATIENT
// =====================================================
export async function saveIdentityPatient(
    patient,
    userName,
    ipAddress,
    userLocation,
    fileName = ""
) {
    console.log("SENDING TO BACKEND:", patient);
    const response = await axios.post(
        `${baseUrl}identity/save/`,
        {
            patient,
            addedby: userName,
            ip_address: ipAddress,
            location: userLocation,
            file_name: fileName
        }
    );
    return response.data;
}